/*
 * @Descripttion:
 * @Author: zhangtingjiang
 * @Date: 2019-11-11 12:02:37
 */

import jwt from 'jsonwebtoken'
const usernameVoidResponse = {
  status: 'error',
  msg: '用户名不为空'
}
const passwordVoidResponse = {
  status: 'error',
  msg: '密码不为空'
}
const usernameErrorResponse = {
  status: 'error',
  msg: '用户名不正确'
}
const passwordErrorResponse = {
  status: 'error',
  msg: '密码不正确'
}
const successResponse = {
  status: 'success',
  data: jwt.sign({
    username: 'admin',
    password: 'admin'
  }, 'www.xxx.com', {
    expiresIn: 60 * 60 * 24
  })
}

export default [
  {
    path: '/api/login',
    type: 'post',
    response: config => {
      const body = JSON.parse(config.body)
      const username = body.username ? body.username : ''
      const password = body.password ? body.password : ''
      if (!username) {
        return usernameVoidResponse
      }
      if (!password) {
        return passwordVoidResponse
      }
      if (username !== 'admin') {
        return usernameErrorResponse
      }
      if (username === 'admin' && password !== 'admin') {
        return passwordErrorResponse
      }
      return successResponse
    }
  }
]



// WEBPACK FOOTER //
// ./src/mocks/modules/login.js